export const MATCH_PATTERN = /^[+(0][0-9()/]{4,19}[0-9]$/;
